import {
    BREAK_CREATE,
    BREAK_LIST,
    BREAK_UPDATE
} from "../actions";

export function breaks(currentState = {}, action) {
    switch (action.type) {
        case BREAK_CREATE:
            return {
                type: action.type,
                list: currentState.list ? currentState.list.concat(action.list) : [action.list]
            }
        case BREAK_LIST:
            return currentState = action
        case BREAK_UPDATE:
            return {
                type: action.type,
                list:  currentState.list.map(current => current.id  === action.list.id ? action.list : current)
            }
        default:
            return currentState
    }
}